export const buildReceiveDeleteState = (state, action) =>
  state.map((product) => {
    if (action.ids.indexOf(product.id) > -1) {
      return { ...product, isDeleted: true, isChecked: false };
    }
    return product;
  });
